import { createEffect } from 'effector';

import { FeeService } from 'apps/admin/services';

export const getTransactionFeePlans = createEffect(FeeService.getTransactionFeePlans);
export const getTransactionFeesForSite = createEffect(FeeService.getTransactionFeesForSite);
export const getSubscriptionFeePlans = createEffect(FeeService.getSubscriptionFeePlans);
export const getSubscriptionFeesForSite = createEffect(FeeService.getSubscriptionFeesForSite);
